import { Box, Chip, Typography } from '@mui/material';
import { ReactComponent as MailIcon } from 'assets/mail-dark.svg';
import { ReactComponent as PhoneIcon } from 'assets/phone-icon.svg';
import { ReactComponent as UserIcon } from 'assets/user-circle.svg';

import { formatPercentage } from 'components/featured/Deals/components/DealDetailsMain/Details/utils';
import { formatDealAmount } from 'helper/short-currency';
import { Link } from 'react-router-dom';
import RoutePaths from 'routes/RoutePaths';
import { BusinessType } from 'store/slices/businessesSlice';
import Logo from '../Logo';
import styles, { primary, widgetValue } from './styles';

const Card = ({ data }: { data: BusinessType }) => {
  const {
    companyId,
    name,
    logo,
    businessType,
    activeDealCount,
    totalSpend,
    clientFitScore,
    keyContact,
  } = data;

  return (
    <Box
      sx={{ ...styles.cardContainer }}
      component={Link}
      to={`${RoutePaths.Businesses}/${companyId}`}
      key={companyId}
    >
      <Box sx={{ ...styles.header }}>
        <Box sx={{ ...styles.logo }}>
          <Logo logo={logo} />
        </Box>
        <Box sx={{ ...styles.title }}>
          <Typography variant='responsiveHeading4'>{name}</Typography>
          <Box sx={{ ...styles.chipsContainer }}>
            <Chip sx={{ ...primary }} label={businessType} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...styles.widgetContainer }}>
        {[
          { value: activeDealCount, formattedValue: activeDealCount, label: 'Active Deals' },
          {
            value: totalSpend,
            formattedValue: formatDealAmount(totalSpend),
            label: 'Total Spend',
          },
          {
            value: clientFitScore,
            formattedValue: formatPercentage(String(clientFitScore)),
            label: 'Client Fit',
          },
        ].map(({ value, formattedValue, label }) => {
          const widgetValueStyles = label === 'Client Fit' ? widgetValue(value) : {};

          return (
            <Box sx={{ ...styles.widget }} key={label}>
              <Typography sx={{ ...widgetValueStyles }} variant='buttonMedium'>
                {formattedValue}
              </Typography>
              <Typography>{label}</Typography>
            </Box>
          );
        })}
      </Box>
      <Box sx={{ ...styles.contactContainer }}>
        {keyContact && (
          <>
            <Box sx={{ ...styles.contact }}>
              <UserIcon style={{ flexShrink: 0 }} />
              <Typography>
                {keyContact.name} ({keyContact.title})
              </Typography>
            </Box>
            <Box sx={{ ...styles.links }}>
              <a href={`tel:${keyContact.phone}`} onClick={(e) => e.stopPropagation()}>
                <PhoneIcon />
              </a>
              <a href={`mailto:${keyContact.email}`} onClick={(e) => e.stopPropagation()}>
                <MailIcon />
              </a>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Card;
